import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0","key":"svg-0"}],["path",{"d":"M13.004 21.216a2 2 0 0 1 -2.417 -.316l-4.244 -4.243a8 8 0 0 1 11.314 -11.314a7.93 7.93 0 0 1 2.343 5.657","key":"svg-1"}],["path",{"d":"M17 19a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-2","key":"svg-2"}],["path",{"d":"M18 18v-1.5a1.5 1.5 0 1 1 3 0v1.5","key":"svg-3"}]]

const IconMapLock = createReactComponent('outline', 'map-lock', 'MapLock', __iconNode);

export default IconMapLock;